import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const billingPersonalizationEnabled = isFeature('billing-personalization-enabled');

export const personalBillingModalEnabled = isFeature('personal-billing-modal-enabled');

/** cloud-4811 фича для переключения на новую ручку billing/personalization/user/data */
export const billingPersonalizationUseDataApi = isFeature('billing-personalization-use-data-api');

/** cloudweb-20655 фича для выбора источника данных: data2 (вкл) или data1 (выкл) */
export const billingPersonalizationDataSource = isFeature('billing-personalization-data-source') ? 'data2' : 'data1';
